import PropTypes from 'prop-types';
import brightspaceLogo from 'assets/images/lms_providers/brightspace.svg';
import brightspaceFailed from 'images/icons/brightspace-failed.svg';
import brightspaceOrphaned from 'images/icons/brightspace-orphaned.svg';
import brightspaceSuccess from 'images/icons/brightspace-success.svg';
import canvasCardIcon from 'images/icons/canvas-red-box.png';
import canvasFailed from 'images/icons/canvas-failed.svg';
import canvasLogo from 'images/icons/canvas_logo.svg';
import canvasOrphaned from 'images/icons/canvas-orphaned.svg';
import canvasSuccess from 'images/icons/canvas-success.svg';
import googleFailed from 'images/icons/google-classroom-failed.svg';
import googleLogo from 'assets/images/google_classroom_logo.svg';
import googleOrphaned from 'images/icons/google-classroom-orphaned.svg';
import googleSuccess from 'images/icons/google-classroom-success.svg';
import schoologyFailed from 'images/icons/schoology-failed.svg';
import schoologyLogo from 'images/icons/schoology-icon.svg';
import schoologyOrphaned from 'images/icons/schoology-orphaned.svg';
import schoologySuccess from 'images/icons/schoology-success.svg';
import { LmsIconKind, LmsKind } from './types';

export interface LmsProviderConfig {
  cardIcon: string;
  icons: {
    failed: string;
    orphaned?: string;
    success: string;
  };
  logo: string;
  name: string;
  shortName: string;
  urls: {
    integration: string;
    setup: string;
    syncDetails?: string;
    troubleshoot?: string;
    unlinkedAssignment?: string;
  };
}

export const LTI_KINDS: LmsKind[] = ['canvas', 'schoology', 'brightspace'];

const BRIGHTSPACE_HELP_ARTICLE = 'https://help.teachtci.com/s/article/TCI-s-Brightspace-Integration';

const LMS_PROVIDERS: Record<LmsIconKind, LmsProviderConfig> = {
  brightspace: {
    cardIcon: brightspaceLogo,
    icons: { failed: brightspaceFailed, orphaned: brightspaceOrphaned, success: brightspaceSuccess },
    logo: brightspaceLogo,
    name: 'Brightspace',
    shortName: 'Brightspace',
    urls: {
      integration: BRIGHTSPACE_HELP_ARTICLE,
      setup: BRIGHTSPACE_HELP_ARTICLE,
      syncDetails: BRIGHTSPACE_HELP_ARTICLE,
    },
  },
  canvas: {
    cardIcon: canvasCardIcon,
    icons: { failed: canvasFailed, orphaned: canvasOrphaned, success: canvasSuccess },
    logo: canvasLogo,
    name: 'Canvas',
    shortName: 'Canvas',
    urls: {
      integration: 'https://www.teachtci.com/canvas-integration',
      setup: 'https://www.teachtci.com/canvas-integration-setup',
      syncDetails: 'https://www.teachtci.com/canvas-sync-details',
      troubleshoot: 'https://www.teachtci.com/troubleshoot-canvas-errors',
      unlinkedAssignment: 'https://www.teachtci.com/canvas-unlinked-assignment',
    },
  },
  google: {
    cardIcon: googleLogo,
    icons: { failed: googleFailed, orphaned: googleOrphaned, success: googleSuccess },
    logo: googleLogo,
    name: 'Google Classroom',
    shortName: 'Google',
    urls: {
      integration: 'https://www.teachtci.com/tci-google-classroom-connect',
      setup: 'https://www.teachtci.com/tci-google-classroom-connect',
      troubleshoot: 'https://www.teachtci.com/troubleshoot-google-classroom-errors',
    },
  },
  schoology: {
    cardIcon: schoologyLogo,
    icons: { failed: schoologyFailed, orphaned: schoologyOrphaned, success: schoologySuccess },
    logo: schoologyLogo,
    name: 'Schoology',
    shortName: 'Schoology',
    urls: {
      integration: 'https://www.teachtci.com/schoology-integration',
      setup: 'https://help.teachtci.com/s/article/Set-up-TCI-s-Schoology-Integration',
      syncDetails: 'https://www.teachtci.com/schoology-sync-details',
      troubleshoot: 'https://www.teachtci.com/troubleshoot-schoology-errors',
      unlinkedAssignment: 'https://www.teachtci.com/schoology-unlinked-assignment',
    },
  },
};

export const lmsProviderConfig = (kind: LmsIconKind): LmsProviderConfig => LMS_PROVIDERS[kind];

export const lmsProviderPropType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  kind: PropTypes.oneOf(LTI_KINDS).isRequired,
  logo_url: PropTypes.string,
  name: PropTypes.string.isRequired,
});

export default LMS_PROVIDERS;
